import { render, staticRenderFns } from "./VideoPlaceholder.vue?vue&type=template&id=0eb132a5&scoped=true&"
import script from "./VideoPlaceholder.vue?vue&type=script&lang=js&"
export * from "./VideoPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlaceholder.vue?vue&type=style&index=0&id=0eb132a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb132a5",
  null
  
)

export default component.exports